import {NewsAll} from "modules/blocks";

export const NewsAllPage = ()=> {
    return (
        <NewsAll />
    )
}
